import React from 'react';
import LoansForm from '../components/LoansForm';

const form1 = () => <LoansForm />;

export default form1;
